import React from 'react';
import PropTypes from 'prop-types';
import { Input } from 'semantic-ui-react';

const StaticTextValue = ({ staticText }) => (
  <Input value={staticText} fluid disabled />
);

StaticTextValue.propTypes = {
  staticText: PropTypes.string.isRequired,
};

export default StaticTextValue;
